import styles from './styles.module.css';
import React, { useState } from 'react';
import i18n from 'i18next';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../../../components/header/Header';
import icSelected from '../../../assets/imgs/ic_selected_language.svg?react';
import { applyFontFromLanguage, showNotificationDialog } from '../../../utils';
import { useFujiAuth } from '../../../auth/useFujiAuth';
import CenterLoading from '../../../components/CenterLoading/CenterLoading';
import { getSelectableLanguages } from '../../../assets/languages/configs';

/**
 * 図20-1 言語設定画面
 */
const Language = () => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const { updateUserAttributes, isAuthenticated } = useFujiAuth();
    const selectableLanguages = getSelectableLanguages();

    /**
     * 言語変更の処理
     * @param {String} key
     */
    const changeLanguage = async (key: string) => {
        try {
            setIsLoading(true);

            if (isAuthenticated) {
                await new Promise((resolve) => updateUserAttributes({}, resolve));
            }

            // 言語を切り替え
            void i18n.changeLanguage(key);
            applyFontFromLanguage(key);

            // ローカルストレージに言語値保存
            localStorage.setItem('lang', key);

            // 言語変更に完了のメッセージを表示
            showNotificationDialog(
                'success',
                'language-change',
                t('notification.title'),
                t('notification.language-change'),
            );
            // マイページに遷移
            navigate(-1);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <React.Fragment>
            {isLoading && <CenterLoading overFooter={true} />}
            <Header title={t('header.language')} />
            <div className="content-footer-container scrollable" style={{ paddingTop: 0 }}>
                {selectableLanguages.map((language) => (
                    <button
                        className={styles.languageItem}
                        onClick={() => void changeLanguage(language.key)}
                        key={language.key}
                    >
                        <div className={styles.iconArea}>
                            {i18n.language === language.key &&
                                React.createElement(icSelected, { className: styles.selectIcon })}
                        </div>
                        <div className={styles.languageItemText}>
                            <p>{language.title}</p>
                            <span>{language.subTitle}</span>
                        </div>
                    </button>
                ))}
            </div>
        </React.Fragment>
    );
};

export default Language;
